import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "el-menu--horizontal" }

import { ref } from "vue";
  import { useRouter } from "vue-router";
    
export default /*@__PURE__*/_defineComponent({
  __name: 'peopleheader',
  setup(__props) {

  const activeIndex2 = ref("1");
  
return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "default-active": activeIndex2.value,
      class: "el-menu-demo",
      mode: "horizontal",
      "background-color": "grey",
      "text-color": "#fff",
      "active-text-color": "#ffd04b",
      router: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Mdata" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("运动数据", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Tanalysis" }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("技术分析", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Ppk" }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("个人PK", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/ltcomp" }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("擂台赛", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Systemnotice" }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" 系统通知", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Minfo" }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("本人信息", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Finfo" }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("好友信息", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/webcomp" }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" 我的比赛", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Mcomment" }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" 我的评论", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Mteam" }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("我的团队", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Mteacher" }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" 我的私教", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/webpage/people/Mfile" }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode(" 私人文件", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}
}

})